<template>
  <div class="container" v-cloak ref="container">
    <div class="container-header">
      <img src="https://oss.swiftfintech.com/txfq_cg/h5/icon_txfq_logo.png" alt="" />
      <!-- 半流程表单将息费提示放到左侧品牌标识下方。 -->
      <div class="entry-annual-rate-notice">
        <span>年化利率(单利)：7.2%~24%(已包含全部息费)</span>
        <span>具体年化以最终授信及签约前明示表为准</span>
      </div>
    </div>
    <Scheme :orderInfoData="orderInfoData" />
    <Advertisement />
    <div class="apply">
      <div class="apply_protocols">
        <van-checkbox v-model="checked" icon-size="0.3rem" class="protocols">
          我已阅读并同意
          <span
            v-for="(item, index) in defaultProtocols"
            :key="item.contractName + index"
            @click.stop="handleProtocol('default', item)"
            class="protocols-title"
            >《{{ item.contractName }}》</span
          >
          <span
            v-if="thirdProtocols?.agreements?.length > 0"
            @click.stop="handleProtocol('third', thirdProtocols)"
            class="protocols-title"
            >《三方协议》</span
          >
        </van-checkbox>
      </div>
      <div class="apply_btn">
        <van-button class="btn" type="info" round block @click="handleSubmit">
          同意并申请
        </van-button>
        <div class="apply_btn_tips">最终放款结果，以三方机构审核为准</div>
      </div>
      <!-- 默认协议弹窗 -->
      <van-action-sheet
        class="protocol-sheet"
        v-model="protocolShow"
        close-on-popstate
        close-on-click-action
        @close="handleCloseProtocol"
      >
        <div slot="default" class="actions-con">
          <p class="pr u-text-center">
            <van-icon
              name="cross"
              size="0.36rem"
              color="#999"
              class="pa"
              @click="protocolShow = false"
            ></van-icon>
            <span>{{ protocolTitle }}</span>
          </p>

          <div class="protocol-con">
            <div v-if="!cilckDefaultProtocols" v-html="protocolContent"></div>
            <iframe v-else :src="protocolUrl" frameborder="0" height="100%"></iframe>
          </div>
        </div>
      </van-action-sheet>
      <!-- 三方协议弹窗 -->
      <van-action-sheet
        class="protocol-sheet"
        v-model="thirdProtocolShow"
        close-on-popstate
        close-on-click-action
        @close="handleCloseThirdProtocol"
      >
        <div slot="default" class="protocal-list actions-con">
          <div
            class="protocal-list-item"
            v-for="(item, index) in thirdProtocols.agreements"
            :key="item.contractName + index"
            @click="handleThirdProtocolClick(item)"
            @close="handleCloseThirdProtocol"
          >
            {{ item.contractName }}
          </div>
        </div>
      </van-action-sheet>
      <!-- 确认同意协议弹窗 -->
      <van-popup
        v-model="agreeMentShow"
        :close-on-click-overlay="false"
        :style="{
          width: '85%',
        }"
        round
        closeable
      >
        <div class="agree-ment u-text-center">
          <h3>服务协议及授权协议</h3>
          <div class="protocols-box">
            我已阅读并同意
            <span
              v-for="(item, index) in defaultProtocols"
              :key="item.contractName + index"
              @click.stop="handleProtocol('default', item)"
              class="protocols-title"
              >《{{ item.contractName }}》</span
            >
            <span
              v-if="thirdProtocols?.agreements?.length > 0"
              @click.stop="handleProtocol('third', thirdProtocols)"
              class="protocols-title"
              >《三方协议》</span
            >
          </div>
          <van-button block color="#4957ff" round @click="handleAgree"> 同意并继续 </van-button>
          <p @click="agreeMentShow = false" class="protocols-disagree">不同意</p>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
import { entryCommon } from '@/mixins/entryCommon.js'
import { mapPosition } from '@/mixins/mapPosition.js'
import formPageLoadTrackMixin from '@/mixins/formPageLoadTrackMixin.js'
import Advertisement from './advertisement.vue'
import Scheme from './scheme.vue'
import { getHalfPickOrderInfo, submitHalfPickConfirm } from '@/api/combinedlogin.js'
export default {
  name: 'combinedHalf',
  mixins: [entryCommon, mapPosition, formPageLoadTrackMixin],
  data() {
    return {
      protocolShow: false,
      thirdProtocolShow: false,
      protocolTitle: '',
      protocolContent: '',
      protocolUrl: '',
      // protocolContentZQGZ: "",
      checked: false,
      agreeMentShow: false,
      orderInfoData: {},
      defaultProtocols: [],
      thirdProtocols: [],
      cilckDefaultProtocols: false,
    }
  },
  components: { Advertisement, Scheme },
  mounted() {
    this.getOrderInfo()
  },
  watch: {},
  computed: {},
  methods: {
    getOrderInfo() {
      getHalfPickOrderInfo({
        source: this.$route.query.source,
        orderId: this.$route.query.orderId,
      }).then((res) => {
        if (res?.code == 200) {
          this.orderInfoData = res.data
          this.defaultProtocols = res.data?.agreements?.defaultAgreements
          this.thirdProtocols = res.data?.agreements?.thirdAgreement
            ? res.data.agreements.thirdAgreement
            : []
        }
      })
    },
    // 获取个人信息共享授权书 和 知情告知书 协议内容
    getProtocol(type) {
      API_Common.getContent({
        pageType: type == 'xxsq' ? 13 : 14,
        source: this.$route.query.source,
      }).then((res) => {
        if (res?.code == 200) {
          this.protocolTitle = res.data.name
          this.protocolContent = res.data.content
        }
      })
    },
    // 打开协议弹窗
    handleProtocol(type, data) {
      if (type === 'default') {
        this.protocolShow = true
        this.protocolTitle = data.contractName
        this.protocolUrl = data.contractUrl
        this.cilckDefaultProtocols = true
      } else {
        this.cilckDefaultProtocols = false
        this.thirdProtocolShow = true
        console.log(data, 'data')
      }
    },
    handleThirdProtocolClick(item) {
      this.thirdProtocolShow = false
      this.protocolShow = true
      this.cilckDefaultProtocols = false
      this.protocolTitle = item.contractName
      this.protocolContent = item.contractContent
      this.protocolUrl = item.contractUrl
    },
    handleCloseThirdProtocol() {},
    // 监听协议弹窗关闭
    handleCloseProtocol() {
      this.protocolTitle = ''
      this.protocolContent = ''
      this.protocolUrl = ''
      if (this.cilckDefaultProtocols) {
        this.thirdProtocolShow = false
      } else {
        this.thirdProtocolShow = true
      }
    },
    handleSubmitConfirm() {
      let data = {
        orderId: this.$route.query.orderId,
        source: this.$route.query.source,
      }
      submitHalfPickConfirm(data).then((res) => {
        if (res?.code == 200) {
          let querydata = {
            source: this.$route.query.source,
            orderId: this.$route.query.orderId,
            productName: this.orderInfoData.productName,
            productLogo: this.orderInfoData.logo,
            jumpUrl: this.orderInfoData.jumpUrl,
            isRedirectProductsPage:
              res.data && res.data.isRedirectProductsPage ? res.data.isRedirectProductsPage : 0,
            isH5DownloadAppShow:
              res.data && res.data.isH5DownloadAppShow ? res.data.isH5DownloadAppShow : 0,
          }
          this.$router.push({
            path: '/combinedHalfSuccess',
            query: querydata,
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleSubmit() {
      if (!this.checked) {
        this.agreeMentShow = true
      } else {
        this.handleSubmitConfirm()
      }
    },
    // 监听是否同意协议弹窗中的按钮
    handleAgree() {
      this.agreeMentShow = false
      this.checked = true
      this.handleSubmitConfirm()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  background: url('https://oss.swiftfintech.com/txfq_cg/h5/bg.png') no-repeat;
  background-size: 100%;
  background-color: #f4f9ff;
  min-height: 100vh;
  padding: 0.5rem 0.3rem;
  .container-header {
    margin-bottom: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    > img {
      width: 2.1rem;
    }
  }
  .apply {
    margin-bottom: 0.5rem;
    .apply_protocols {
      display: flex;
      flex-direction: row;
      .protocols {
        display: flex;
        align-items: baseline;
        margin: 0.2rem 0;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        .protocols-title {
          color: #3563fa;
        }
      }
    }
    .apply_btn {
      text-align: center;
      .apply_btn_tips {
        margin-top: 0.3rem;
        color: #f8e1b0;
        font-size: 0.24rem;
      }
    }
  }
  .yuan {
    z-index: 1;
    position: relative;
    margin: auto;
    width: 100%;
    height: 4rem;
    background-color: #fef4dc;
    border-radius: 0.2rem;
  }
  .yuan::before,
  .yuan::after {
    z-index: 0;
    content: '';
    position: absolute;
    top: 33%; /* 高度的 2/3 */
    width: 20px;
    height: 20px; /* 半圆形的高度 */
    background-color: #fff; /* 白色 */
    border-radius: 50%; /* 创建半圆形 */
  }

  .yuan::before {
    left: -10px;
  }

  .yuan::after {
    right: -10px;
  }
  // .yuan::after {
  //   content: "";
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   width: 2px; /* 虚线的宽度 */
  //   height: 50px; /* 虚线的高度 */
  //   background-color: #000; /* 虚线的颜色 */
  //   transform: translate(-50%, -50%); /* 居中 */
  //   border-radius: 1px; /* 创建虚线 */
  //   background-image: linear-gradient(
  //     to right,
  //     #000 25%,
  //     transparent 25%,
  //     transparent 50%,
  //     #000 50%,
  //     #000 75%,
  //     transparent 75%,
  //     transparent
  //   );
  //   background-size: 10px 10px;
  // }
  // 协议弹窗样式
  .protocol-sheet {
    height: 75%;
    .actions-con {
      height: 100%;
      padding: 0.38rem 0.48rem;
      overflow: hidden;
    }
    .actions-con .van-icon {
      left: 0;
      top: 0;
    }
    .actions-con p.pr {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.3rem;
    }
    .protocol-con {
      height: calc(100% - 0.78rem);
      overflow: auto;
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      text-align: justify;
      color: #747576;
      line-height: 0.48rem;
    }
    // 三方协议弹窗样式
    .protocal-list {
      margin-top: 0.5rem;
      font-size: 0.28rem;
      .protocal-list-item {
        border-radius: 0.2rem;
        background-color: #f4f6ff;
        // color: red;
        padding: 0.2rem 0.36rem;
        margin-bottom: 0.2rem;
      }
    }
  }
  // 确认是否同意协议弹窗样式
  .agree-ment {
    font-size: 0.28rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #111c31;
    padding: 0.6rem 0.36rem;
    .agree-ment > h3 {
      margin: 0 -0.36rem 0.3rem;
    }
    .agree-ment > p {
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #8991a0;
      margin-bottom: 0.3rem;
    }
    .protocols-box {
      margin-bottom: 0.3rem;
    }
    .protocols-title {
      color: #346ef4;
    }
    .protocols-disagree {
      margin-top: 0.2rem;
    }
  }
}
</style>
